export const COMMON_FIELDS = [
  { id: -1, label: "childrenUpdated", type: "boolean" },
  { id: 0, label: "locallyUpdatedAt", type: "number" },
  { id: 1, label: "dateCreated", type: "string" },
  { id: 2, label: "dateModified", type: "string" },
  { id: 4, label: "recordOwner", type: "object" },
  { id: 5, label: "lastModifiedBy", type: "object" },
];
